import React, { useEffect, useRef, useState } from 'react';

const Trackvisibilty = () => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null, // Use the viewport as root
        rootMargin: '0px', // No margin around root
        threshold: 0.1, // Trigger if 10% of the target is visible
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  return (
    <div style={{ height: '200vh' }}>
      <div style={{ height: '100vh' }}>Scroll down to see the tracked element</div>
      
      <div
        ref={elementRef}
        style={{
          height: '100px',
          backgroundColor: isVisible ? 'green' : 'red',
          transition: 'background-color 0.5s',
        }}
      >
        {isVisible ? 'I am visible!' : 'I am not visible!'}
      </div>
      
      <div style={{ height: '100vh' }}>Keep scrolling to toggle visibility</div>
    </div>
  );
};

export default Trackvisibilty;
